import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
    <div className="footer-content">
    
        {/* Contact Info */}
        <div className="footer-contact">
            <div className='email'><i className="fas fa-envelope"></i> admin@tifleducation.com</div>

        {/* Social Icons */}
        <div className="footer-socials">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="https://www.instagram.com/tifleducation.official/"><i className="fab fa-instagram"></i></a>

        {/* Copyright */}
        </div>
        <p className="footer-copy">© {new Date().getFullYear()} TIFL. All rights reserved.</p>

        </div>
    </div>
</footer>
  );
};

export default Footer;
